import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { CustomDynamicResultTable } from '@css-xp/base';

export const RightAlignedTd = styled.td`
  text-align: right;
  overflow: visible !important; // required to show dropdown action menu
`;

export const EndCustomerContactsContainer = styled.div`
  display: block;
  float: right;
  margin-right: ${token('space.0')} !important;

  .end-customer-contacts-no-data {
    margin-right: ${token('space.100')} !important;
  }
`;

export const BillingProfilesCount = styled.span`
  display: flex;
  gap: ${token('space.050')};
  align-items: center;
  div:first-child {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    color: ${token('color.text.subtlest')};
  }
`;

export const BillingProfilesAddress = styled.td`
  > div {
    //  override the default styles for the address column fom table.scss
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;

    p {
      color: ${token('color.text.subtlest')};
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    // Show ellipsis for billing profile name in sub row if text goes beyond available width to avoid overlapping
    & > div > div {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const CustomerListTableContainer = styled(CustomDynamicResultTable)`
  .col-billing-profiles {
    width: 650px;
  }

  .col-customer-contacts{
    width: 220px;
  }

  .col-subscriptions {
    width: 170px;
  }

  thead {
    th:not(:first-child) {
      text-align: right;
    }
  }

  .grouped-child {
    td:first-child {
      padding-left: ${token('space.800')} !important; // to match the design for left padding when row is expanded
    }
  }

  table tbody > tr:hover {
    background-color: var(
      --ds-surface-sunken
    ); !important; // to override the default hover behavior of none as it only highlights first td instead of whole row
  }

  .expandable-row {
    border-top: 1px solid ${token('color.border.disabled')} !important; // to override the default border color
    :hover {
      background-color: var(
        --ds-surface-sunken
      ) !important; // to override the default hover behavior of none as it only highlights first td instead of whole row
    }
  }

  .expandable-loader-v2 {
    left: 0 !important; // to override the default left value
  }

  .customer-contact-avatar-group {
    // to override the default margin-right and display, as per new design contacts are right aligned
    margin-right: 0 !important;
    display: flex !important;
    justify-content: flex-end;
  }

  .custom-search-wrapper {
    width: 350px;
  }

  td.end-customer-contacts-loader-column {
    padding-right: 0 !important; // targeting customer contacts td, to override the default padding-right
  }
`;
